import instanceAxios from './axiosConfig';

export const getDataTopUSer = async () => {
  try {
    const data = {
      query: `mutation {
                get_top_ref_user {
                  top {
                    name
                    phone
                    invite_count
                    rank
                    company
                    top
                  }
                  total_system_meet_count
                  user_count
                  diamond_user_count
                  ruby_user_count
                  sapphire_user_count
                }
              }`,
    };
    const result = await instanceAxios.post('', data);
    return result.data;
  } catch (error) {
    console.log(error);
  }
};

export const getDataReport = async (filter) => {
  try {
    const data = {
      query: `mutation {
                get_user_invite_list(input: {
                  search_value: "${filter.search}"
                  page_index: ${filter.page - 1}
                  page_size: ${filter.limit}
                }) {
                  data {
                    name
                    phone
                    invite_count
                    rank
                    company
                  }
                  total
                }
              }`,
    };
    const result = await instanceAxios.post('', data);
    return result.data;
  } catch (error) {
    console.log(error);
  }
};
